import { formatPhoneNumberIntl } from 'react-phone-number-input';

export const CONTACT_PHONE_NUMBER = '+48732191011';
export const CONTACT_PHONE_NUMBER_FORMATTED = formatPhoneNumberIntl(CONTACT_PHONE_NUMBER);

export const CONTACT_EMAIL = 'info@avalio.io';
